<template>
  <v-app>
    <v-content>
      <router-view />
    </v-content>
    <Loader />
    <Message />
  </v-app>
</template>

<script>
import Loader from "./components/Loader";
import Message from "./components/Message.vue";
import { auth } from "./assets/js/firebase";

export default {
  name: "App",
  components: { Loader, Message },
  data: () => ({}),
  beforeDestroy() {
    this.$store.dispatch("removeListen");
  },
  mounted() {
    const vm = this;
    auth.onAuthStateChanged(user => {
      if (user) {
        vm.$store.dispatch("listen");
      }
    });
  }
};
</script>
